"use client";
import {
  Box,
  Heading,
  Stack,
  Text,
  useColorModeValue as mode,
} from "@chakra-ui/react";
import { ButtonProp, PageBlockBreakpoint } from "lib/gcms";
import { mapButton } from "utils/map-button";

export const Breakpoint = (props: PageBlockBreakpoint) => {
  return (
    <Box
      as="section"
      px={{
        base: "12",
        lg: "20",
      }}
      py="24"
      bg={props?.bg}
      color={props?.color}
    >
      <Stack
        spacing="6"
        direction={{ base: "column", md: "row" }}
        align={{ md: "center" }}
        justify="space-between"
        maxW={{ base: "xl", md: "7xl" }}
        mx="auto"
        px={{ base: "6", md: "8" }}
      >
        <Box
          textAlign={{
            base: "center",
            lg: "left",
          }}
        >
          <Text
            mb="2"
            fontSize="lg"
            fontWeight="semibold"
            color={mode("gray.600", "gray.400")}
          >
            {props.highlight}
          </Text>
          <Heading
            size="xl"
            fontWeight="extrabold"
            maxW={{
              base: "full",
              lg: "20ch",
            }}
          >
            {props.title}
          </Heading>
          {props.children}
        </Box>
        <Stack
          direction={{ base: "column", md: "row" }}
          spacing={{ base: "5", md: "5" }}
          align="center"
          justifyContent={{
            base: "flex-start",
            lg: "space-between",
          }}
        >
          {props?.buttons.map((button, idx) =>
            mapButton(button as ButtonProp, { key: idx, size: "lg" }),
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export default Breakpoint;
